import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { fetchInvite, acceptInvite, startFlagshipProgram, mediaUrl } from '../lib/programsApi';

const SERIF = { fontFamily: "'Playfair Display', serif" };

export default function JourneyInvitePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  const [together, setTogether] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { fetchInvite(token).then(setD).catch(() => setErr('This invitation is no longer available.')); }, [token]);
  useEffect(() => { if (user) localStorage.removeItem('rbr_pending_invite'); }, [user]);
  const start = async () => {
    if (!user) { localStorage.setItem('rbr_pending_invite', `${d.program.slug}:${token}`); toast('Sign in to start — your invitation is kept'); navigate('/auth'); return; }
    setBusy(true);
    try {
      await acceptInvite(token, together);
      localStorage.setItem('rbr_pending_invite', `${d.program.slug}:${token}`);
      await startFlagshipProgram(d.program.slug);
      navigate(`/programs/${d.program.slug}`);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  if (err) return <div className="px-5 py-16 text-center text-[#e3d2a8]" data-testid="invite-unavailable"><p>{err}</p></div>;
  if (!d) return <div className="px-5 pt-8"><div className="aspect-[4/3] rounded-3xl bg-white/10 animate-pulse" /></div>;
  const p = d.program;
  return (
    <div className="px-5 py-8 max-w-md mx-auto animate-fade-in" data-testid="journey-invite-page">
      <div className="rounded-3xl overflow-hidden"><img src={mediaUrl(p.coverImageUrl, 800)} alt={p.title} className="w-full aspect-[4/3] object-cover" /></div>
      <p className="mt-5 text-sm italic text-[#e3d2a8]" data-testid="invite-page-message">“{d.message}” <span className="not-italic text-[#e3d2a8]/70">— {d.inviterFirstName}</span></p>
      <p className="text-[10px] uppercase tracking-[0.25em] text-[#e3d2a8]/80 mt-4">{p.category} · {p.totalDays} {p.dayLabel}s</p>
      <h1 className="text-3xl font-bold text-[#f9f4ea] leading-tight" style={SERIF} data-testid="invite-page-title">{p.title}</h1>
      <p className="text-sm text-[#e3d2a8] mt-1">{p.tagline}</p>
      <p className="text-sm text-[#e3d2a8]/80 mt-3 leading-relaxed">{p.description}</p>
      {d.startTogether && (
        <label className="flex items-start gap-2 mt-4 text-xs text-[#e3d2a8] rounded-2xl border border-[#e3d2a8]/30 p-3" data-testid="invite-page-together">
          <input type="checkbox" checked={together} onChange={(e) => setTogether(e.target.checked)} data-testid="invite-page-together-checkbox" />
          <span>{d.inviterFirstName} offered to <b>start together</b>. Opt in to share gentle high-level updates (started / completed) with each other — nothing private.</span>
        </label>
      )}
      <button type="button" disabled={busy} onClick={start} className="mt-5 w-full h-12 rounded-full bg-[#D6AD60] text-[#0f1e33] text-xs font-semibold uppercase tracking-[0.2em] disabled:opacity-50" data-testid="invite-start">{user ? 'Start This Journey' : 'Sign in to start this journey'}</button>
      <p className="text-[11px] text-[#e3d2a8]/70 text-center mt-2">Nothing starts until you choose to.</p>
    </div>
  );
}
